import React from "react";

import { stylize } from "@envestnet/envreact-component-library";
import withIntl from "utils/withIntl";

import Logo from "images/EnvLogo";

import AuthenticatorHeader from "components/AuthenticatorHeader";

import OktaVerifyStepOne from "components/OktaVerifyStepOne";
import OktaVerifyStepThree from "components/OktaVerifyStepThree";
import OktaVerifyStepTwo from "components/OktaVerifyStepTwo";
import { mfaFlow } from "utils/enum";
import { AppTypeEnum } from "./enums";

import styles from "./styles";
import { StatusType, SubmissionStateType } from "./types";

type DefaultProps = {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below

  /** Description of this prop */

  loadQRCode: Function;
  submitPassCode: Function;
  loadStatus: Function;
  resetSubmissionStatus: Function;
  loadingPassCodeSubmission: SubmissionStateType;
  qrCodeLink: string;
  status: StatusType;
  secretCode: string;
  username: string;
};

interface OktaAuthProps {
  hideLogo: boolean;
  activeStep: number;
  redirectToMfa: Function;
  setActiveStep: Function;
  authenticatorName: string;
  currentLayout: mfaFlow;
}

type Props = OktaAuthProps & DefaultProps;
const OktaAuth = (props: Props) => {
  const {
    hideLogo,

    redirectToMfa,
    loadQRCode,
    qrCodeLink,
    submitPassCode,
    loadingPassCodeSubmission,
    loadStatus,
    status,
    setActiveStep,
    secretCode,
    resetSubmissionStatus,
    username,
    activeStep,
    authenticatorName,
    currentLayout,
  } = props;
  return (
    <>
      {!hideLogo && <Logo />}
      <AuthenticatorHeader
        authenticatorName={authenticatorName}
        userId={username}
      />
      {activeStep === 1 && (
        <OktaVerifyStepOne
          onNext={() => loadStatus({ authenticatorType: AppTypeEnum.OKTA })}
          onCancel={redirectToMfa}
          loadQRCode={loadQRCode}
          status={status}
          qrCodeLink={qrCodeLink}
          currentLayout={currentLayout}
          onCantScan={() => {
            setActiveStep(3);
          }}
        />
      )}
      {activeStep === 2 && (
        <OktaVerifyStepTwo
          onCancel={redirectToMfa}
          onBack={() => setActiveStep(1)}
          onSubmitPassCode={submitPassCode}
          processingStatus={loadingPassCodeSubmission}
          resetSubmissionStatus={resetSubmissionStatus}
        />
      )}

      {activeStep === 3 && (
        <OktaVerifyStepThree
          onNext={() => loadStatus({ authenticatorType: AppTypeEnum.OKTA })}
          status={status}
          secretCode={secretCode}
          onCancel={redirectToMfa}
        />
      )}
    </>
  );
};

export default withIntl(stylize<Props, DefaultProps>(styles)(OktaAuth));
